import { useNumberSearchParam } from '../../hooks/useNumberSearchParam';
import { RouteUrlParam } from '../../enums/RouteUrlParam';

export function useAssetsPackSearchParam() {
  return useNumberSearchParam(RouteUrlParam.Pack);
}
